import { useState, useEffect } from "react";
import { saveEducationDetails, getAllResources } from "../Api/EducationDetails";
import { Form, Button, Row, Col } from "react-bootstrap";
import { toast } from "react-toastify";
import Sample14 from "../Components/Logo";

const EducationDetails = () => {
  const [loading, setLoading] = useState(false);
  const [resources, setResources] = useState([]);
  const userName = localStorage.getItem("username") || "defaultUser";

  const educationCodes = [
    { code: "101", name: "10th" },
    { code: "102", name: "12th" },
    { code: "103", name: "Graduation" },
    { code: "104", name: "Post Graduation" },
    { code: "105", name: "Diploma" }
  ];

  const years = Array.from({ length: 76 }, (_, i) => 1960 + i); // 1960 to 2035

  const [educationData, setEducationData] = useState({
    resourceId: "",
    educationCode: "",
    educationType: "",
    instituteName: "",
    yearOfPassing: "",
    grade: ""
  });

  useEffect(() => {
    const fetchResources = async () => {
      try {
        setLoading(true);
        const resourcesData = await getAllResources();
        setResources(resourcesData);
      } catch (error) {
        toast.error("Error loading resources");
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchResources();
  }, []);

  const handleChange = (e) => {
    setEducationData({ ...educationData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await saveEducationDetails(educationData, userName);
      toast.success("🦄 Education Details Added Successfully");
      setEducationData({
        resourceId: "",
        educationCode: "",
        educationType: "",
        instituteName: "",
        yearOfPassing: "",
        grade: ""
      });
    } catch (error) {
      toast.error("🦄 Some Error Happened");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fields-container">
      <h2 className="fields-title">Education Details</h2>

      <Form onSubmit={handleSubmit} className="fields-form">
        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Resource ID <span className="text-red">**</span></Form.Label>
              <Form.Control
                as="select"
                name="resourceId"
                value={educationData.resourceId}
                onChange={handleChange}
                required
              >
                <option value="">Select Resource</option>
                {resources.map((resource) => (
                  <option key={resource.resourceId} value={resource.resourceId}>
                    {resource.resourceId} - {resource.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Education Code <span className="text-red">**</span></Form.Label>
              <Form.Control
                as="select"
                name="educationCode"
                value={educationData.educationCode}
                onChange={handleChange}
                required
              >
                <option value="">Select Education</option>
                {educationCodes.map((edu) => (
                  <option key={edu.code} value={edu.code}>
                    {edu.code} - {edu.name}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Education Type <span className="text-red">**</span></Form.Label>
              <Form.Control
                type="text"
                name="educationType"
                value={educationData.educationType}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Institute Name <span className="text-red">**</span></Form.Label>
              <Form.Control
                type="text"
                name="instituteName"
                value={educationData.instituteName}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Year of Passing <span className="text-red">**</span></Form.Label>
              <Form.Control
                as="select"
                name="yearOfPassing"
                value={educationData.yearOfPassing}
                onChange={handleChange}
                required
              >
                <option value="">Select Year</option>
                {years.map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))}
              </Form.Control>
            </Form.Group>
          </Col>
          <Col md={4}>
            <Form.Group className="mb-3">
              <Form.Label>Grade or % <span className="text-red">**</span></Form.Label>
              <Form.Control
                type="text"
                name="grade"
                value={educationData.grade}
                onChange={handleChange}
                required
              />
            </Form.Group>
          </Col>
        </Row>

        <div className="fields-btn-container">
          <Button variant="primary" type="submit" className="fields-submit">
            Save Education Details
          </Button>
        </div>
      </Form>

      {loading && (
        <div className="loading-overlay">
          <Sample14 />
        </div>
      )}
    </div>
  );
};

export default EducationDetails;